/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Validation_Dob_Invalid_FormatInputs */

const en_clients_validation_dob_invalid_format = /** @type {(inputs: Clients_Validation_Dob_Invalid_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the format YYYY-MM-DD.`)
};

const pt_br2_clients_validation_dob_invalid_format = /** @type {(inputs: Clients_Validation_Dob_Invalid_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use o formato AAAA-MM-DD.`)
};

/**
* | output |
* | --- |
* | "Use the format YYYY-MM-DD." |
*
* @param {Clients_Validation_Dob_Invalid_FormatInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_dob_invalid_format = /** @type {((inputs?: Clients_Validation_Dob_Invalid_FormatInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_Dob_Invalid_FormatInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_dob_invalid_format(inputs)
	return pt_br2_clients_validation_dob_invalid_format(inputs)
});